var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .667C4.405.667.667 4.405.667 9c0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.333-3.738 8.333-8.333C17.333 4.405 13.595.667 9 .667zM2.333 9c0-.75.13-1.468.36-2.14L4 8.166l1.667 1.666V11.5l1.666 1.667.834.833v1.61C4.884 15.196 2.333 12.392 2.333 9zm11.942 4.06c-.544-.438-1.37-.727-1.942-.727V11.5a1.667 1.667 0 00-1.666-1.667H7.333v-2.5A1.667 1.667 0 009 5.667v-.834h.833A1.667 1.667 0 0011.5 3.167v-.343c2.44.991 4.167 3.384 4.167 6.176 0 1.47-.49 2.9-1.392 4.06z",
    fill: "#BDBDBD"
  })));
}

export default SvgWorld;